var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"container-fluid"},[_c('vehicle-view-global',{attrs:{"vehicle":_vm.estimate.vehicle,"view-header":false,"show-edit-btn":""},on:{"onViewVehicle":function($event){return _vm.$emit('onViewEstimate')}},scopedSlots:_vm._u([{key:"header",fn:function(){return [_c('span')]},proxy:true}])})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }